<template>
  <div class="powered-by">
    <h1>Powered by</h1>
    <div class="header-wrapper">
      <div class="top">
        <h2>Enable Mars part</h2>
        <a-switch :checked="poweredByData.mars_enabled" @change="handleMars" />
      </div>
      <div class="bottom">
        <p>Enable/Disable Mars part of the footer</p>
      </div>
      <div class="top">
        <h2>Enable/Disable Powered by section in footer.</h2>
        <a-switch :checked="poweredByData.enabled" @change="onChange" />
      </div>
      <div class="bottom">
        <p>This sections displays powered by label accompanied by logo.</p>
      </div>
    </div>
    <!-- <div class="input-wrap">
      <div class="label-wrap">
        <label for="">Input Label</label>
        <span class="material-icons"> help_outline </span>
      </div>
      <a-input :value="poweredByData.label" @input="emitPoweredByLabel" maxlength="255" />
    </div> -->
    <div>
      <!-- <SinglePartnerLogo
        :el="elFormatted"
        :controls="false"
        @partnerLogoImage="handlePartnerLogo"
        @domainValue="handleDomainValue"
      /> -->
    </div>
  </div>
</template>

<script>
// import SinglePartnerLogo from "./SinglePartnerLogo.vue";
export default {
  components: {
    // SinglePartnerLogo,
  },
  props: {
    footerData: {
      type: Object,
    },
  },
  computed: {
    poweredByData() {
      return this.footerData.powered_by;
    },
    elFormatted () {
      return {
        domain: this.poweredByData.url,
        img: this.poweredByData.image,
      };
    },
  },
  methods: {
    onChange(checked) {
      this.$emit("togglePoweredBy",checked)
    },
    handleMars (checked) {
      this.$emit("poweredByMars", checked);
    },
    handlePartnerLogo(obj) {
      this.$emit("footerImage", obj);
    },
    handleDomainValue(obj) {
      this.$emit("poweredByDomain", obj.domain);
    },
    emitPoweredByLabel(evt) {
      this.$emit("poweredByLabel", evt.target.value);
    },
  },
};
</script>

<style scoped lang='scss'>
.powered-by {
  margin: 40px 0 0 0;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    padding: 25px 0;
    border-bottom: 1px solid #cbcbe4;
  }
  .header-wrapper {
    max-width: 800px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 500px;
      padding: 32px 0 14px 0;
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        margin: 0;
        line-height: 21px;
        color: #001529;
      }
    }
    .bottom {
      margin: 0 0 32px 0;
      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
    }
  }
  .input-wrap {
    display: flex;
    margin: 25px 0;
    .material-icons {
      color: #b2bac7;
      font-size: 14px;
      display: inline-block;
      margin: 0 5px;
    }
    .label-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #001529;
        width: 70px;
      }
    }
  }
}
</style>

<style>
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.powered-by
  > div.input-wrap
  > input {
  width: 150px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  box-sizing: border-box;
  border-radius: 2px;
}
</style>